import styled from '@emotion/styled'

export const CustomSection = styled.section`
  background-color: #fff;
  padding: 30px 30px 200px;

  article {
    width: calc(100% - 100px);
    margin: 0 auto;
  }

  h1 {
    text-align: center;
    margin-bottom: 50px;
  }

  h2 {
    margin-bottom: 15px;
  }

  h3 {
    margin-bottom: 5px;
  }

  ul {
    padding-left: 20px;
    margin-bottom: 20px;
    list-style-type: disc;

    li {
      margin-bottom: 5px;
    }
  }

  p {
    margin-bottom: 10px;
    line-height: 1.6;
  }

  a {
    display: inline-block;
    padding: 5px 10px;
    margin-right: 10px;
    background-color: #4d4d4d;
    color: #fff;
    text-decoration: none;
    border-radius: 5px;
    font-size: 13px;
    margin-bottom: 8px;

    &.view {
      margin: 0 0 70px;
    }
  }

  .techStackUL {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    @media (max-width: 640px) {
      flex-direction: column;
      gap: 5px;
    }
  }

  @media (max-width: 640px) {
    padding: 50px 15px 100px;

    article {
      width: 100%;
    }
  }
`

export const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;

  @media (max-width: 640px) {
    max-width: calc(100% - 20px);
  }
`

export const PreviewGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin: 12px 0 30px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`

export const PreviewItem = styled.button`
  position: relative;
  border: 0;
  padding: 0;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background-color: #111;
  min-height: 115px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.2s ease;
  }

  &:hover img {
    transform: scale(1.03);
  }

  .counter {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: 700;
  }
`

export const GalleryModal = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.9);
  padding: 24px;

  .closeGalleryButton {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 40px;
    height: 40px;
    border: 0;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.15);
    color: #fff;
    cursor: pointer;
    z-index: 3;
  }

  .galleryContent {
    max-width: 980px;
    margin: 50px auto 0;
  }

  .image-gallery-slide img {
    max-height: calc(100vh - 170px);
    object-fit: contain;
  }

  .image-gallery-thumbnail img {
    height: 56px;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    padding: 15px;

    .galleryContent {
      margin-top: 40px;
    }

    .image-gallery-slide img {
      max-height: calc(100vh - 200px);
    }
  }
`

export const Slice = styled.div`
  height: 2px;
  background-color: #888;
  margin: 40px 0;
`
